(() => {
  "use strict";

  // header
  document.addEventListener("DOMContentLoaded", () => {
    const currentPath = location.pathname.replace(/\/$/, "");

    document.querySelectorAll(".l-header__nav-list-item-link").forEach((link) => {
      const linkPath = link.getAttribute("href").replace(/\/$/, "");

      if (linkPath === "") {
        if (currentPath === "") {
          link.classList.add("-current");
        }
        return;
      }

      if (currentPath === linkPath || currentPath.startsWith(linkPath + "/")) {
        link.classList.add("-current");
      }
    });
  });

  // header-menu
  jQuery(function ($) {
    $(document).on("click", ".js-header-button", function (e) {
      e.preventDefault();

      const $buttons = $(".js-header-button");
      const $aside = $(".js-header-aside");
      const aside = $aside.get(0);

      // $buttons.css({ "pointer-events": "none" });

      $(this).addClass("-active");

      $aside
        .stop(true, true)
        .delay(100)
        .queue(function (next) {
          $aside.removeClass("-passive").addClass("-active");
          next();
        });

      $("body").addClass("-active");
      bodyScrollLock.disableBodyScroll(aside);

      // setTimeout(function () {
      //   $buttons.css({ "pointer-events": "auto" });
      // }, 1000);
    });

    $(document).on("click", ".js-header-button-close", function (e) {
      e.preventDefault();

      const $buttons = $(".js-header-button");
      const $aside = $(".js-header-aside");
      const aside = $aside.get(0);

      // $buttons.css({ "pointer-events": "none" });

      $buttons.removeClass("-active");
      $aside.removeClass("-active").addClass("-passive");

      $aside
        .stop(true, true)
        .delay(600)
        .queue(function (next) {
          $("body").removeClass("-active");
          bodyScrollLock.enableBodyScroll(aside);
          next();
        });

      // setTimeout(function () {
      //   $buttons.css({ "pointer-events": "auto" });
      // }, 1000);
    });
  });

  // mv・news高さ調整
  jQuery(function ($) {
    const mv = document.querySelector(".js-top-mv");
    const wrapper = document.querySelector(".js-top-mv-wrapper");
    const news = document.querySelector(".js-top-news");
    const why = document.querySelector(".js-top-why");

    if (mv && news) {
      function setHeight() {
        const wrapperHeight = wrapper.clientHeight;
        const paddingTop = parseFloat(getComputedStyle(wrapper).paddingTop);
        const newsHalf = news.offsetHeight / 2;
        let totalHeight = wrapperHeight + paddingTop + newsHalf;
        const newsHeight = news.offsetHeight;
        const halfHeight = Math.round(newsHeight / 2);

        if (window.matchMedia("(max-width: 767px)").matches) {
          totalHeight -= 32;
        }

        mv.style.height = totalHeight + "px";
        why.style.paddingTop = halfHeight + "px";
      }

      const observer = new ResizeObserver(() => {
        setHeight();
      });

      observer.observe(news);
    }
  });

  jQuery(function ($) {
    function setPadding() {
      const newsHeight = $(".js-top-news").outerHeight();
      const halfHeight = Math.round(newsHeight / 2);
      $(".js-top-why").css("padding-top", halfHeight + "px");
    }

    setPadding();

    $(window).on("resize", function () {
      setPadding();
    });
  });

  // scrollbar
  function scrollbar() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);

    document.documentElement.style.setProperty("--vw-offset", `${(window.innerWidth - document.documentElement.clientWidth) / 2}px`);
  }

  scrollbar();
  window.addEventListener("resize", scrollbar);

  // news
  jQuery(function ($) {
    $(".js-top-news-list").each(function () {
      const count = $(this).children("li").length;

      if (count >= 3) {
        $(this).addClass("-active");
      }
    });
  });

  // why
  jQuery(function ($) {
    $(".js-top-why-link li").hover(function () {
      const index = $(this).index();

      $(".js-top-why-img li").removeClass("-active").eq(index).addClass("-active");
    });
  });

  // accordion sp
  jQuery(function ($) {
    $(".js-sp-accordion").on("click", function () {
      const $this = $(this);
      const $target = $this.children().next(".js-sp-target");
      $(".js-sp-accordion").not($this).removeClass("-open").children().next(".js-sp-target").stop().slideUp(300, "easeOutQuad");
      $this.toggleClass("-open");
      $target.stop().slideToggle(300, "easeOutQuint");
    });
  });

  // accordion pc
  jQuery(function ($) {
    $(".js-pc-accordion").hover(function () {
      const $this = $(this);
      const $target = $this.children().next(".js-pc-target");
      $(".js-pc-accordion").not($this).removeClass("hover");
      // $(".js-pc-target").not($target).removeClass("-active");
      $this.toggleClass("-hover");
      // $target.toggleClass("-active");
    });

    jQuery(function ($) {
      $(".js-pc-accordion").on("click", function () {
        const $this = $(this);
        if ($this.hasClass("-open")) {
          $(".js-pc-accordion").removeClass("-open -close");
        } else {
          $(".js-pc-accordion").removeClass("-open").addClass("-close");
          $this.removeClass("-close").addClass("-open");
        }
      });
    });
  });

  // animation
  jQuery(function ($) {
    var onElemInview = function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("u-inview-active");
        }
      });
    };
    var options = {
      rootMargin: "0px 0px -100px",
    };
    var observer = new IntersectionObserver(onElemInview, options);
    var nodelist = document.querySelectorAll("[data-inview]");
    var node = Array.prototype.slice.call(nodelist, 0);
    node.forEach(function (elem) {
      observer.observe(elem);
      elem.classList.add("u-inview-ready");
    });
  });

  // アンカーリンク
  jQuery(function ($) {
    $("a[href^='#']").on("click", function (e) {
      e.preventDefault();
      const targetId = $(this).attr("href");
      const $target = $(targetId);
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - $(".js-header").outerHeight(),
          },
          500,
          "swing",
        );
      }
    });
  });

  // 404
  jQuery(function ($) {
    function setMainMinHeight() {
      const headerH = $(".js-header").outerHeight() || 0;
      const footerH = $(".js-footer").outerHeight() || 0;

      const minH = window.innerHeight - headerH - footerH;

      $(".js-main").css("min-height", minH + "px");
    }

    setMainMinHeight();

    $(window).on("resize", function () {
      setMainMinHeight();
    });
  });

  // form validation
  document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector("#js-form");

    if (!form) return;

    const validation = new JustValidate(form, {
      submitFormAutomatically: true,
      focusInvalidField: false,
    });

    validation.onFail(() => {
      requestAnimationFrame(() => {
        const errorTargets = Array.from(form.querySelectorAll(".just-validate-error-label, .just-validate-error-field"))
          .map((el) => el.closest(".p-contact__form-table-tr") || el)
          .filter((el, index, self) => self.indexOf(el) === index);

        if (!errorTargets.length) return;

        const topMostErrorTarget = errorTargets.reduce((top, current) => {
          return current.getBoundingClientRect().top < top.getBoundingClientRect().top ? current : top;
        });

        const headerHeight = jQuery(".js-header").outerHeight() || 0;
        const targetTop = topMostErrorTarget.getBoundingClientRect().top + window.scrollY - headerHeight;

        jQuery("html, body")
          .stop(true)
          .animate(
            {
              scrollTop: Math.max(targetTop, 0),
            },
            500,
            "swing",
          );
      });
    });

    validation
      .addField("#inquiry", [
        {
          rule: "required",
          errorMessage: "入力してください",
        },
      ])

      .addField("#name", [
        {
          rule: "required",
          errorMessage: "入力してください",
        },
      ])

      .addField("#email1", [
        {
          rule: "required",
          errorMessage: "入力してください",
        },
        {
          rule: "email",
          errorMessage: "有効なメールアドレスを入力してください",
        },
      ])

      .addField("#email2", [
        {
          rule: "required",
          errorMessage: "入力してください",
        },
        {
          validator: (value, fields) => {
            return value === fields["#email1"].elem.value;
          },
          errorMessage: "メールアドレスが一致しません",
        },
      ])

      .addField("#tel", [
        {
          validator: (value) => {
            if (value.trim() === "") {
              return true;
            }
            return /^[0-9]{10,11}$/.test(value);
          },
          errorMessage: "電話番号を正しく入力してください",
        },
      ])

      .addField("#agree", [
        {
          rule: "required",
          errorMessage: "チェックしてください",
        },
      ]);

    // 一度フォーカスアウトした項目だけリアルタイムチェック
    const touched = {};

    ["#inquiry", "#name", "#email1", "#email2", "#tel"].forEach((selector) => {
      const element = document.querySelector(selector);

      if (!element) return;

      touched[selector] = false;

      element.addEventListener("blur", () => {
        touched[selector] = true;
        validation.revalidateField(selector);
      });

      element.addEventListener("input", () => {
        if (touched[selector]) {
          validation.revalidateField(selector);
        }

        // email1変更時はemail2も再チェック
        if (selector === "#email1" && touched["#email2"] && document.querySelector("#email2").value !== "") {
          validation.revalidateField("#email2");
        }
      });
    });

    // チェックボックス
    document.querySelector("#agree").addEventListener("change", () => {
      validation.revalidateField("#agree");
    });
  });
})();
